import React from "react";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";

const HeaderSurvey = (props) => {
  const history = useHistory();

  const withStyle = props.location.pathname !== "/result";
  const goBack = () => {
    if (props.currentStep === 1) {
      history.push(`/`);
    }
    if (props.currentStep === 2) {
      props.setCurrentStep(1);
    }
    if (props.currentStep === 3) {
      props.setCurrentStep(2);
    }
    if (props.currentStep === 4) {
      props.setCurrentStep(3);
    }
    if (props.currentStep === 5) {
      props.setCurrentStep(4);
    }
  };
  return (
    <header
      className="header_class pp-quiz--header"
      style={{ background: props.currentStep === 5 ? "#f3fbff" : "" }}
    >
      <a className="pp-quiz-back" onClick={goBack}>
        <i style={{ fontSize: "16px" }} className="fa fa-chevron-left mr-2"></i>{" "}
        Back
      </a>
      {props.currentStep != 5 && (
        <a className="pp-quiz-logo" href="/" style={{marginLeft:"-62px"}}>
          <img
            alt="DawaAsaan Logo"
            src={require("../../assets/images/Logo.png")}
          />
        </a>
      )}
      <a className="pp-quiz-close" href="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.777"
          height="20.777"
          viewBox="0 0 55.777 55.777"
        >
          <g
            id="Group_690"
            data-name="Group 690"
            transform="translate(-6443.671 -1281.672)"
          >
            <line
              id="Line_8"
              data-name="Line 8"
              x2="50.12"
              y2="50.12"
              transform="translate(6446.5 1284.5)"
              fill="none"
              stroke="#919191"
              strokeLinecap="round"
              strokeWidth={4}
            />
            <line
              id="Line_9"
              data-name="Line 9"
              x1="50.12"
              y2="50.12"
              transform="translate(6446.5 1284.5)"
              fill="none"
              stroke="#919191"
              strokeLinecap="round"
              strokeWidth={4}
            />
          </g>
        </svg>
      </a>
    </header>
  );
};
export default withRouter(HeaderSurvey);
